import { render, staticRenderFns } from "./ShippingStatusCounters.vue?vue&type=template&id=ca7555da&scoped=true&"
import script from "./ShippingStatusCounters.vue?vue&type=script&lang=js&"
export * from "./ShippingStatusCounters.vue?vue&type=script&lang=js&"
import style0 from "./ShippingStatusCounters.vue?vue&type=style&index=0&id=ca7555da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7555da",
  null
  
)

export default component.exports